// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Taxonomies
import { gearboxCore, gearboxListing } from '../../../taxonomies/gearbox';

// This component
export default function Gearbox() {
  // Taxonomies
  const { endpoint } = gearboxCore();
  const { initialSort, initialFilters, getColumns, getRows, getFilters } = gearboxListing();

  // Listing
  const {
    page,
    setPage,
    pageSize,
    setPageSize,
    activeFilters,
    saveActiveFilters,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'taxonomy',
        // Static
        initialFilters,
        endpoint,
        getColumns,
        getRows,
        getFilters,
        // Dynamic
        page,
        setPage,
        pageSize,
        setPageSize,
        activeFilters,
        saveActiveFilters,
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Transmissions"
        buttonNewLabel="New Transmission"
        buttonNewUrl="/transmission/new"
        exportAction={false}
      />
    </ListingContext.Provider>
  );
}
